<template>
  <span
    class="contact-avatar"
    :style="{ width: `${size}px`, height: `${size}px`, fontSize: `${Math.round(size * 0.38)}px` }"
    :title="name"
  >
    <img
      v-if="src && !failed"
      :src="src"
      :alt="name"
      class="contact-avatar__img"
      referrerpolicy="no-referrer"
      @error="failed = true"
    />
    <span v-else class="contact-avatar__initials" aria-hidden="true">{{ initials }}</span>
  </span>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";

// A contact's profile photo, or their initials when there's none (or it fails to load:
// LinkedIn photo links expire).
const props = withDefaults(
  defineProps<{
    name: string;
    src?: string | null;
    size?: number;
  }>(),
  { src: null, size: 36 }
);

const failed = ref(false);
watch(
  () => props.src,
  () => (failed.value = false)
);

const initials = computed(() => {
  const parts = props.name.trim().split(/\s+/).filter(Boolean);
  const letters = parts.length > 1 ? [parts[0], parts[parts.length - 1]] : parts;
  return letters.map((p) => p[0]!.toUpperCase()).join("") || "?";
});
</script>

<style scoped>
.contact-avatar {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 50%;
  background: linear-gradient(135deg, #e0e7ff, #ede9fe);
  color: #4c1d95;
  font-weight: 600;
  line-height: 1;
}

.contact-avatar__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
